// import React, { useState, useEffect, useRef } from "react";
// import FormSide from "../../components/services-details/FormSide";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import { ChevronDownIcon } from "@heroicons/react/24/outline";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const SubserviceDetails = () => {
//   const [subservice, setSubservice] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState(0);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const sectionRefs = useRef([]);
//   const tabsContainerRef = useRef(null);
//   const dropdownRef = useRef(null);

//   const { id: subserviceId } = useParams();

//   useEffect(() => {
//     AOS.init({ duration: 1000 });
//     window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {
//     const fetchSubservice = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/subservices/get-subservice-by-id/${subserviceId}`
//         );
//         setSubservice(response.data);
//       } catch (error) {
//         console.error("Error fetching subservice:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (subserviceId) fetchSubservice();
//     else setLoading(false);
//   }, [subserviceId]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     if (!subservice?.data?.overview?.length) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const index = sectionRefs.current.findIndex((ref) => ref === entry.target);
//             if (index !== -1) {
//               setActiveTab(index);
//             }
//           }
//         });
//       },
//       { threshold: 0.5 }
//     );

//     sectionRefs.current.forEach((ref) => ref && observer.observe(ref));

//     return () => sectionRefs.current.forEach((ref) => ref && observer.unobserve(ref));
//   }, [subservice]);

//   const scrollToSection = (index) => {
//     if (sectionRefs.current[index]) {
//       sectionRefs.current[index].scrollIntoView({ behavior: "smooth" });
//     }
//     setActiveTab(index);
//     setShowDropdown(false);
//   };

//   if (loading)
//     return (
//       <div className="flex justify-center items-center h-60 text-xl font-semibold">
//         Loading service details...
//       </div>
//     );

//   if (!subservice || !subservice.data)
//     return (
//       <div className="flex justify-center items-center h-60 text-red-500 text-xl font-semibold">
//         Service not found
//       </div>
//     );

//   const serviceData = subservice.data;

//   return (
//     <div className=" bg-gray-50">
//       {/* HEADER SECTION */}
//       <div className="container mx-auto px-4 md:px-10 py-10">
//         <div className="flex flex-col lg:flex-row gap-10">
//           {/* LEFT CONTENT */}
//           <div className="w-full lg:w-2/3 space-y-6" data-aos="fade-up">
//             <h1 className="text-2xl md:text-4xl font-semibold text-gray-800 leading-snug">
//               {serviceData.title || serviceData.SubserviceName}
//             </h1>

//             {/* Description */}
//             {serviceData.description?.length > 0 && (
//               <div className="text-gray-600 text-lg leading-relaxed space-y-3 text-justify">
//                 {serviceData.description.map((desc, i) => (
//                   <p key={i} dangerouslySetInnerHTML={{ __html: desc }} />
//                 ))}
//               </div>
//             )}

//             {/* Images Grid */}
//             {serviceData.images?.length > 0 && (
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 rounded-xl overflow-hidden">
//                 {serviceData.images.map((img, i) => (
//                   <img
//                     key={i}
//                     src={img}
//                     className="w-full h-64 object-cover rounded-xl shadow-md"
//                     alt={serviceData.SubserviceName}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* RIGHT FORM */}
//           <div className="w-full lg:w-1/3">
//             <div className="sticky top-24">
//               <FormSide />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* OVERVIEW TABS */}
//       {serviceData.overview?.length > 0 && (
//         <div className="w-full bg-white shadow-lg rounded-xl py-6 mt-6">
//           {/* TABS */}
//           <div
//             ref={tabsContainerRef}
//             className="sticky top-[4.3rem] md:top-[3rem] z-30 bg-white border-b shadow-sm overflow-x-auto flex scrollbar-hide"
//           >
//             {/* Mobile Dropdown */}
//             <div className="md:hidden w-full px-3" ref={dropdownRef}>
//               <button
//                 onClick={() => setShowDropdown(!showDropdown)}
//                 className="w-full bg-orange-500 text-white py-3 px-4 rounded-lg flex justify-between items-center font-semibold"
//               >
//                 {serviceData.overview[activeTab]?.name}
//                 <ChevronDownIcon className={`w-5 h-5 ${showDropdown ? "rotate-180" : ""}`} />
//               </button>

//               {showDropdown && (
//                 <div className="bg-white shadow-lg rounded-lg mt-2 border p-2 space-y-1">
//                   {serviceData.overview.map((item, index) => (
//                     <button
//                       key={index}
//                       onClick={() => scrollToSection(index)}
//                       className={`w-full text-left p-3 rounded-md font-medium transition ${
//                         activeTab === index ? "bg-orange-100 text-orange-700" : "hover:bg-gray-100"
//                       }`}
//                     >
//                       {item.name}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* Desktop Tabs */}
//             <div className="hidden md:flex gap-2 px-4 py-3">
//               {serviceData.overview.map((item, index) => (
//                 <button
//                   key={index}
//                   id={`tab-${index}`}
//                   onClick={() => scrollToSection(index)}
//                   className={`px-6 py-3 rounded-lg text-lg font-semibold whitespace-nowrap transition-all ${
//                     activeTab === index
//                       ? "bg-orange-500 text-white shadow-md"
//                       : "text-gray-700 hover:bg-orange-100"
//                   }`}
//                 >
//                   {item.name}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* CONTENT SECTIONS */}
//           <div className="container mx-auto px-4 md:px-10 mt-10 space-y-16">
//             {serviceData.overview.map((item, index) => (
//               <section
//                 key={index}
//                 ref={(el) => (sectionRefs.current[index] = el)}
//                 className="scroll-mt-24"
//               >
//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
//                   {/* TEXT */}
//                   <div className="space-y-4">
//                     {item.title && (
//                       <h2 className="text-3xl font-bold text-gray-800">{item.title}</h2>
//                     )}

//                     {item.description?.length > 0 && (
//                       <div className="space-y-3 text-lg text-gray-700 leading-relaxed text-justify">
//                         {item.description.map((desc, i) => (
//                           <p key={i} dangerouslySetInnerHTML={{ __html: desc }} />
//                         ))}
//                       </div>
//                     )}

//                     {item.points?.length > 0 && (
//                       <div className="mt-4 space-y-6">
//                         {item.points.map((point, i) => (
//                           <div key={i}>
//                             <h3 className="text-2xl font-semibold text-gray-800">
//                               {point.heading}
//                             </h3>
//                             <p
//                               className="text-gray-700 text-lg leading-relaxed text-justify"
//                               dangerouslySetInnerHTML={{ __html: point.description }}
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>

//                   {/* IMAGE (Sticky on top for each section) */}
//                   {item.images?.length > 0 && (
//                     <div className="sticky top-36">
//                       <img
//                         src={item.images[0]}
//                         className="w-full h-[500px] object-cover rounded-xl shadow-md"
//                         alt={item.name}
//                       />
//                     </div>
//                   )}
//                 </div>
//               </section>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* AUTHOR */}
//       {(serviceData.authorName || serviceData.authorDescription) && (
//         <div className="container mx-auto px-4 md:px-10 py-10">
//           <div className="bg-gray-100 p-6 rounded-xl shadow-md">
//             <h2 className="text-2xl font-bold mb-2">Author</h2>

//             {serviceData.authorName && (
//               <p className="text-gray-700 text-lg">
//                 Written by
//                 <span className="text-blue-600 font-semibold"> {serviceData.authorName}</span>
//               </p>
//             )}

//             {serviceData.authorDescription && (
//               <p
//                 className="mt-3 text-gray-700 leading-relaxed text-lg text-justify"
//                 dangerouslySetInnerHTML={{ __html: serviceData.authorDescription }}
//               />
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SubserviceDetails;


import React, { useState, useEffect, useRef } from "react";
import FormSide from "../../components/services-details/FormSide";
import SEO from "../../components/common/SEO";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import AOS from "aos";
import "aos/dist/aos.css";

const SubserviceDetails = () => {
  const [subservice, setSubservice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const sectionRefs = useRef([]);
  const tabsContainerRef = useRef(null);
  const dropdownRef = useRef(null);

  // Get both slug and id from params
  const { slug, subSlug, id } = useParams();
  const identifier = slug || subSlug || id;

  // Helper to strip HTML tags
  const stripHtml = (html) => {
    if (!html) return '';
    const text = html.replace(/<[^>]*>/g, ' ');
    return text.replace(/\s+/g, ' ').trim();
  };

  // Check if identifier looks like a MongoDB ObjectID (24 hex chars)
  const isObjectId = (str) => /^[0-9a-fA-F]{24}$/.test(str);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchSubservice = async () => {
      try {
        setLoading(true);
        let response;

        if (!identifier) {
          setLoading(false);
          return;
        }

        const looksLikeId = isObjectId(identifier);

        try {
          if (looksLikeId) {
            // Try fetching by ID first
            // console.log("🔍 Fetching by ID:", identifier);
            response = await axios.get(
               `${process.env.REACT_APP_API_URL}/subservices/get-subservice-by-slug/${identifier}`
            );
          } else {
            // Try fetching by slug first
            // console.log("🔍 Fetching by slug:", identifier);
            response = await axios.get(
              `${process.env.REACT_APP_API_URL}/subservices/get-subservice-by-slug/${identifier}`
             
            );
          }
        } catch (firstError) {
          // console.log("⚠️ First attempt failed, trying alternate method...");
          // If first method failed, try the other
          if (looksLikeId) {
            // Try slug if ID failed
            response = await axios.get(
              `${process.env.REACT_APP_API_URL}/subservices/get-subservice-by-id/${identifier}`
            );
          } else {
            // Try ID if slug failed
            response = await axios.get(
              `${process.env.REACT_APP_API_URL}/subservices/get-subservice-by-id/${identifier}`
            );
          }
        }

        setSubservice(response.data);
      } catch (error) {
        console.error("❌ Error fetching subservice:", error);
        setSubservice(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSubservice();
  }, [identifier]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!subservice?.data?.overview?.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = sectionRefs.current.findIndex((ref) => ref === entry.target);
            if (index !== -1) {
              setActiveTab(index);
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    sectionRefs.current.forEach((ref) => ref && observer.observe(ref));

    return () => sectionRefs.current.forEach((ref) => ref && observer.unobserve(ref));
  }, [subservice]);

  const scrollToSection = (index) => {
    if (sectionRefs.current[index]) {
      sectionRefs.current[index].scrollIntoView({ behavior: "smooth" });
    }
    setActiveTab(index);
    setShowDropdown(false);
  };

  // Get SEO data
  const getSeoData = () => {
    if (!subservice?.data) {
      return {
        title: "Subservice - BBSR Services",
        description: "Professional business solutions and services",
        keywords: "BBSR Services, business solutions, subservice",
        canonical: "https://www.bbsrservices.co.in/sub-service"
      };
    }

    const data = subservice.data;
    const serviceName = data.service?.serviceName || "Services";

    return {
      title: data.metaTitle || `${data.subserviceName} | ${serviceName} | BBSR Services`,
      description: data.metaDescription || (data.description && data.description.length > 0
        ? stripHtml(data.description[0]).substring(0, 160)
        : `${data.subserviceName} - ${serviceName} Services`),
      keywords: data.metaKeywords || `${data.subserviceName}, ${serviceName}, BBSR Services, business solutions`,
      canonical: data.canonicalUrl || `https://www.bbsrservices.co.in/sub-service/${data.slug || data._id}`,
      image: data.images?.[0] || data.logo || "https://www.bbsrservices.co.in/logo.png"
    };
  };

  const seoData = getSeoData();

  if (loading)
    return (
      <div className="flex justify-center items-center h-60 text-xl font-semibold">
        Loading service details...
      </div>
    );

  if (!subservice || !subservice.data)
    return (
      <div className="flex justify-center items-center h-60 text-red-500 text-xl font-semibold">
        Service not found
      </div>
    );

  const serviceData = subservice.data;

  return (
    <>
      {/* SEO Meta Tags */}
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
        image={seoData.image}
        type="article"
        author={serviceData.authorName || "BBSR Services"}
        publishedTime={serviceData.createdAt}
      />

      <div className="bg-gray-50">
        {/* HEADER SECTION */}
        <div className="container mx-auto px-4 md:px-10 py-10">
          <div className="flex flex-col lg:flex-row gap-10">
            {/* LEFT CONTENT */}
            <div className="w-full lg:w-2/3 space-y-6" data-aos="fade-up">
              {/* SEO-friendly URL display */}
              {/* <div className="text-sm text-gray-500 bg-white/80 px-3 py-1 rounded-lg inline-block">
                <span className="font-medium">🔗 URL:</span> /sub-service/{serviceData.slug || serviceData._id}
              </div> */}

              <h1 className="text-2xl md:text-4xl font-semibold text-gray-800 leading-snug">
                {serviceData.title || serviceData.subserviceName}
              </h1>

              {/* Description */}
              {serviceData.description?.length > 0 && (
                <div className="text-gray-600 text-lg leading-relaxed space-y-3 text-justify">
                  {serviceData.description.map((desc, i) => (
                    <p key={i} dangerouslySetInnerHTML={{ __html: desc }} />
                  ))}
                </div>
              )}

              {/* Images Grid */}
              {serviceData.images?.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 rounded-xl overflow-hidden">
                  {serviceData.images.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      className="w-full h-64 object-cover rounded-xl shadow-md"
                      alt={serviceData.subserviceName}
                      loading="lazy"
                    />
                  ))}
                </div>
              )}
            </div>

            {/* RIGHT FORM */}
            <div className="w-full lg:w-1/3">
              <div className="sticky top-24">
                <FormSide />
              </div>
            </div>
          </div>
        </div>

        {/* OVERVIEW TABS - Rest of your component */}
        {serviceData.overview?.length > 0 && (
          <div className="w-full bg-white shadow-lg rounded-xl py-6 mt-6">
            {/* TABS */}
            <div
              ref={tabsContainerRef}
              className="sticky top-[4.3rem] md:top-[3rem] z-30 bg-white border-b shadow-sm overflow-x-auto flex scrollbar-hide"
            >
              {/* Mobile Dropdown */}
              <div className="md:hidden w-full px-3" ref={dropdownRef}>
                <button
                  onClick={() => setShowDropdown(!showDropdown)}
                  className="w-full bg-orange-500 text-white py-3 px-4 rounded-lg flex justify-between items-center font-semibold"
                >
                  {serviceData.overview[activeTab]?.name}
                  <ChevronDownIcon className={`w-5 h-5 ${showDropdown ? "rotate-180" : ""}`} />
                </button>

                {showDropdown && (
                  <div className="bg-white shadow-lg rounded-lg mt-2 border p-2 space-y-1">
                    {serviceData.overview.map((item, index) => (
                      <button
                        key={index}
                        onClick={() => scrollToSection(index)}
                        className={`w-full text-left p-3 rounded-md font-medium transition ${
                          activeTab === index ? "bg-orange-100 text-orange-700" : "hover:bg-gray-100"
                        }`}
                      >
                        {item.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Desktop Tabs */}
              <div className="hidden md:flex gap-2 px-4 py-3">
                {serviceData.overview.map((item, index) => (
                  <button
                    key={index}
                    id={`tab-${index}`}
                    onClick={() => scrollToSection(index)}
                    className={`px-6 py-3 rounded-lg text-lg font-semibold whitespace-nowrap transition-all ${
                      activeTab === index
                        ? "bg-orange-500 text-white shadow-md"
                        : "text-gray-700 hover:bg-orange-100"
                    }`}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            </div>

            {/* CONTENT SECTIONS */}
            <div className="container mx-auto px-4 md:px-10 mt-10 space-y-16">
              {serviceData.overview.map((item, index) => (
                <section
                  key={index}
                  ref={(el) => (sectionRefs.current[index] = el)}
                  className="scroll-mt-24"
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
                    {/* TEXT */}
                    <div className="space-y-4">
                      {item.title && (
                        <h2 className="text-3xl font-bold text-gray-800">{item.title}</h2>
                      )}

                      {item.description?.length > 0 && (
                        <div className="space-y-3 text-lg text-gray-700 leading-relaxed text-justify">
                          {item.description.map((desc, i) => (
                            <p key={i} dangerouslySetInnerHTML={{ __html: desc }} />
                          ))}
                        </div>
                      )}

                      {item.points?.length > 0 && (
                        <div className="mt-4 space-y-6">
                          {item.points.map((point, i) => (
                            <div key={i}>
                              <h3 className="text-2xl font-semibold text-gray-800">
                                {point.heading}
                              </h3>
                              <p
                                className="text-gray-700 text-lg leading-relaxed text-justify"
                                dangerouslySetInnerHTML={{ __html: point.description }}
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* IMAGE (Sticky on top for each section) */}
                    {item.images?.length > 0 && (
                      <div className="sticky top-36">
                        <img
                          src={item.images[0]}
                          className="w-full h-[500px] object-cover rounded-xl shadow-md"
                          alt={item.name}
                          loading="lazy"
                        />
                      </div>
                    )}
                  </div>
                </section>
              ))}
            </div>
          </div>
        )}

        {/* AUTHOR */}
        {(serviceData.authorName || serviceData.authorDescription) && (
          <div className="container mx-auto px-4 md:px-10 py-10">
            <div className="bg-gray-100 p-6 rounded-xl shadow-md">
              <h2 className="text-2xl font-bold mb-2">Author</h2>

              {serviceData.authorName && (
                <p className="text-gray-700 text-lg">
                  Written by
                  <span className="text-blue-600 font-semibold"> {serviceData.authorName}</span>
                </p>
              )}

              {serviceData.authorDescription && (
                <p
                  className="mt-3 text-gray-700 leading-relaxed text-lg text-justify"
                  dangerouslySetInnerHTML={{ __html: serviceData.authorDescription }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SubserviceDetails;